import type {
  GovernanceCheckPreviewResponse,
  GovernanceCheckResponse,
} from '$/requests/GovernanceCheck.ts';
import type { LedgerCommitResponse } from '$/requests/LedgerCommit.ts';
import type { GovernedRecommendationContent } from '@/pages/recommendationEngine/governedRecommendationTypes.ts';

export const RECOMMENDATION_ENGINE_STEPS = [
  'recommendation',
  'commitment-checkpoint',
  'governance-review',
  'compass-review',
  'fiduciary-escalation',
  'session-recorded',
] as const;

export type FrameworkLogicMatch = 'yes' | 'no';

export type RecommendationEngineSteps = typeof RECOMMENDATION_ENGINE_STEPS;

export type RecommendationLoadPhase = 'interpretation-reveal' | 'strategic-case-ready';

/** How the user exited COMPASS — drives session-recorded vs fiduciary path. */
export type SessionCompletionRoute = 'complete' | 'caution' | 'escalation';

export type SessionRecordedOutcome = 'ledger_success' | 'ledger_error' | 'escalated' | 'pending';

export type RecommendationEngineData = {
  decision_id?: string;
  loadPhase?: RecommendationLoadPhase;
  recommendation?: GovernedRecommendationContent;
  governance_preview?: GovernanceCheckPreviewResponse;
  framework_attribution?: string;
  framework_logic_match?: FrameworkLogicMatch;
  commitment_confidence?: number;
  primary_assumption?: string;
  governance_result?: GovernanceCheckResponse;
  governance_sealed?: boolean;
  completion_route?: SessionCompletionRoute;
  session_outcome?: SessionRecordedOutcome;
  ledger_commit?: LedgerCommitResponse;
  escalation_reason?: string;
  save_session_language?: boolean;
};
